import {addToWishList, removeFromWishList, fetchItems} from '../utils/wishlist';
import getFormProperties from '../utils/getFormProperties';

import initProductNotifyMe from './product-notify-me';

async function ProductCard(container) {
  const swatches = container.querySelectorAll('.swatch');
  const addToCartForm = container.querySelector('.product-card__form');
  const addToCartBtn = container.querySelector('.product-card__add');
  const variantSelector = container.querySelector('[data-product-select]');
  const selectedVariantId = variantSelector?.options[variantSelector.selectedIndex]?.value;
  const {productId, productHandle, productPrice} = container.dataset;
  const wishlistContainer = document.querySelector('.wishlist-container');
  const addToWishlistBtn = container.querySelector('[data-product-card-wishlist-add]');

  // Handle colour swatch click
  swatches?.forEach((swatch) => {
    swatch.addEventListener('click', (event) => {
      event.preventDefault();
      if (swatch.matches('.swatch--active')) return;
      const swatchHandle = swatch.dataset.product;
      replaceProduct(event, swatchHandle);
    });
  });

  // Handle add to cart
  addToCartBtn?.addEventListener('click', (event) => {
    event.preventDefault();
    if (!selectedVariantId) return;
    const addedLabel = container.querySelector('.product-card__added');
    const item = {
      id: selectedVariantId,
      quantity: 1,
      properties: getFormProperties(addToCartForm),
    };
    window.sideCart.handleAddToCartEvent(item, true);
    addedLabel.classList.add('show');
    setTimeout(() => {
      addedLabel.classList.remove('show');
    }, 2000);
  });

  // Handle wishlist functionality
  if (addToWishlistBtn) {
    const wishlistItems = await fetchItems();

    let isThisWishlisted = wishlistItems.some((item) => Number(item.epi) === Number(selectedVariantId));

    const wishlistProductData = {
      epi: selectedVariantId,
      du: `${window.location.origin}/products/${productHandle}`,
      empi: productId,
      pr: productPrice,
    };

    const isRecommendedProduct = wishlistContainer && container.closest('.product-recommendations__slider');

    if (isThisWishlisted) {
      // If we are on wishlist page, hide product if it's already saved
      if (isRecommendedProduct) {
        container.parentElement.classList.add('hide');
        document.dispatchEvent(new Event('resizeRecommendationsSlider'));
        return;
      }
      addToWishlistBtn.classList.add('is-wishlisted');
      addToWishlistBtn.setAttribute('aria-label', window.theme.strings.wishlist.remove);
    } else {
      addToWishlistBtn.classList.remove('is-wishlisted');
      addToWishlistBtn.setAttribute('aria-label', window.theme.strings.wishlist.add);
    }

    addToWishlistBtn.addEventListener('click', () => {
      if (isThisWishlisted) {
        removeFromWishList(wishlistProductData);

        if (wishlistContainer) {
          document.dispatchEvent(
            new CustomEvent('removedFromWishList', {
              detail: wishlistProductData,
            })
          );
          return;
        }

        addToWishlistBtn.classList.remove('is-wishlisted');
        addToWishlistBtn.setAttribute('aria-label', window.theme.strings.wishlist.add);
        isThisWishlisted = false;
      } else {
        addToWishList(wishlistProductData);

        if (wishlistContainer) {
          document.dispatchEvent(
            new CustomEvent('addedToWishList', {
              detail: wishlistProductData,
            })
          );
          return;
        }

        addToWishlistBtn.classList.add('is-wishlisted');
        addToWishlistBtn.setAttribute('aria-label', window.theme.strings.wishlist.remove);
        isThisWishlisted = true;
      }
    });
  }

  // Initialise notify me modal
  initProductNotifyMe(container);

  /**
   * Function that updates product card with new fetched product
   */
  async function replaceProduct(event, handle) {
    const rootUrl = window.theme.locale && window.theme.locale.primary ? '' : window.theme.locale.rootUrl;
    const url = `${rootUrl}/products/${handle}?view=card`;

    const response = await fetch(url);
    if (response.ok) {
      const contentFetched = await response.text();
      const parser = new DOMParser();
      const containerFetched = parser.parseFromString(contentFetched, 'text/html');
      const productCardFetched = containerFetched.querySelector('.product-card');

      const originalSwatches = container.querySelector('.swatches-container');
      const originalSwatchesLabel = originalSwatches
        .querySelector('.swatch--active')
        ?.getAttribute('title')
        .replace('Selected ', '');
      originalSwatches.querySelector('.swatch--active')?.setAttribute('title', originalSwatchesLabel);
      originalSwatches.querySelector('.swatch--active')?.classList.remove('swatch--active');

      const selectedSwatchesLabel = event.target.getAttribute('title');
      event.target.setAttribute('title', `Selected ${selectedSwatchesLabel}`);
      event.target.classList.add('swatch--active');
      const originalSwatchesContent = originalSwatches.innerHTML;

      container.innerHTML = productCardFetched.innerHTML;

      container.dataset.productId = productCardFetched.dataset.productId;
      container.dataset.productHandle = productCardFetched.dataset.productHandle;
      container.dataset.productPrice = productCardFetched.dataset.productPrice;

      const newSwatches = container.querySelector('.swatches-container');
      newSwatches.innerHTML = originalSwatchesContent;

      ProductCard(container);
    }
  }
}

export default ProductCard;
